import React, { useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import AppTextField from "./AppTextField";

export default function AppPasswordField({ endIcon, ...props }) {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible((visible) => !visible);
  };

  return (
    <AppTextField
      {...props}
      type={isPasswordVisible ? "text" : "password"}
      endIcon={
        endIcon || (
          <Tooltip title={isPasswordVisible ? "Ẩn mật khẩu" : "Hiển thị mật khẩu"}>
            <IconButton
              onClick={togglePasswordVisibility}
              onMouseDown={(event) => event.preventDefault()}
              edge="end"
              aria-label={isPasswordVisible ? "Ẩn mật khẩu" : "Hiển thị mật khẩu"}
            >
              {isPasswordVisible ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </Tooltip>
        )
      }
    />
  );
}
